define("ember-intl/helpers/format-relative", ["exports", "ember-intl/helpers/-format-base"], function (_exports, _formatBase) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  /**
   * Copyright 2015, Yahoo! Inc.
   * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
   */
  var _default = _exports.default = _formatBase.default.extend({
    format(params, hash) {
      return this.intl.formatRelative(params, hash);
    },
    compute(params) {
      let hash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._super(params, hash);
    }
  });
});